import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setToken, setData } from "../../../constant/token";
import { postDataWrapper } from "../../../lib/axios";
export interface signIn {
    email: string;
    password: string;
  }

export const loginFetch = createAsyncThunk<signIn, signIn>(
  "admin/login",
  async (data, thunkAPI) => {
    try {
      const response: any =  await axios.post(
        "https://api-dev-buzzhr.developersorcalo.com/auth/signin", {
        email: data.email,
        password: data.password,
      });
      setToken(response.data.data.authToken);
    //   setData(response.data.data.user)
      console.log(response.data, "response.data.data.user");
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
